const Enums = {
    ESORT: {
        NONE: -1,
        STR: 0,
        NUM: 1,
        DATETIME: 2
    },
    E_ITEM: {
        TEXT: 0,
        OPTION: 1,
        TIME: 2,
        NUMBER: 3,
        RADIO: 4,
        TEXTAREA: 5,
        IMAGE: 6,
        EMPTY: 7,
        GENDER: 8,
        CITY_AREA: 9,
        JOB: 10,
        EDU: 11
    },
    E_GENDER: {
        MALE: 1,
        FEMALE: 2
    },
    E_GENDER_TEXT: {
        0: "不限定",
        1: "男",
        2: "女"
    },
    E_EDU_TEXT: {
        1: "小學(含)以下",
        2: "國中",
        3: "高中(職)",
        4: "專科",
        5: "大學",
        6: "研究所(含)以上"
    },
    E_JOB_TEXT: {
        1: "一般白領上班族",
        2: "藍領上班族",
        3: "學生",
        4: "老闆/自營商",
        5: "軍公教",
        6: "家庭主婦",
        7: "退休人員",
        8: "自由業/待業中",
        9: "其他"
    },
    E_CITY_TEXT: {
        1: "臺北市",
        2: "新北市",
        3: "桃園市",
        4: "臺中市",
        5: "臺南市",
        6: "高雄市",
        7: "基隆市",
        8: "新竹市",
        9: "嘉義市",
        10: "新竹縣",
        11: "苗栗縣",
        12: "彰化縣",
        13: "南投縣",
        14: "雲林縣",
        15: "嘉義縣",
        16: "屏東縣",
        17: "宜蘭縣",
        18: "花蓮縣",
        19: "台東縣",
        20: "澎湖縣",
        21: "金門縣",
        22: "連江縣"
    },
    E_CITY_AREA_TEXT: {
        1: "松山區",
        2: "大安區",
        3: "中正區",
        4: "萬華區",
        5: "大同區",
        6: "中山區",
        7: "文山區",
        8: "南港區",
        9: "內湖區",
        10: "士林區",
        11: "北投區",
        12: "信義區",
        13: "新莊區",
        14: "林口區",
        15: "五股區",
        16: "蘆洲區",
        17: "三重區",
        18: "泰山區",
        19: "新店區",
        20: "石碇區",
        21: "深坑區",
        22: "坪林區",
        23: "烏來區",
        24: "板橋區",
        25: "三峽區",
        26: "鶯歌區",
        27: "樹林區",
        28: "中和區",
        29: "土城區",
        30: "瑞芳區",
        31: "平溪區",
        32: "雙溪區",
        33: "貢寮區",
        34: "金山區",
        35: "萬里區",
        36: "淡水區",
        37: "汐止區",
        38: "三芝區",
        39: "石門區",
        40: "八里區",
        41: "永和區",
        42: "桃園區",
        43: "大溪區",
        44: "中壢區",
        45: "楊梅區",
        46: "蘆竹區",
        47: "大園區",
        48: "龜山區",
        49: "八德區",
        50: "龍潭區",
        51: "平鎮區",
        52: "新屋區",
        53: "觀音區",
        54: "復興區",
        55: "中區",
        56: "東區",
        57: "西區",
        58: "南區",
        59: "北區",
        60: "西屯區",
        61: "南屯區",
        62: "北屯區",
        63: "豐原區",
        64: "東勢區",
        65: "大甲區",
        66: "清水區",
        67: "沙鹿區",
        68: "梧棲區",
        69: "神岡區",
        70: "后里區",
        71: "大雅區",
        72: "潭子區",
        73: "新社區",
        74: "石岡區",
        75: "外埔區",
        76: "大安區",
        77: "烏日區",
        78: "大肚區",
        79: "龍井區",
        80: "霧峰區",
        81: "太平區",
        82: "大里區",
        83: "和平區",
        84: "東區",
        85: "南區",
        86: "北區",
        87: "安南區",
        88: "安平區",
        89: "中西區",
        90: "新營區",
        91: "鹽水區",
        92: "白河區",
        93: "柳營區",
        94: "後壁區",
        95: "東山區",
        96: "麻豆區",
        97: "下營區",
        98: "六甲區",
        99: "官田區",
        100: "大內區",
        101: "佳里區",
        102: "西港區",
        103: "七股區",
        104: "將軍區",
        105: "北門區",
        106: "學甲區",
        107: "新化區",
        108: "善化區",
        109: "新巿區",
        110: "安定區",
        111: "山上區",
        112: "玉井區",
        113: "楠西區",
        114: "南化區",
        115: "左鎮區",
        116: "仁德區",
        117: "歸仁區",
        118: "關廟區",
        119: "龍崎區",
        120: "永康區",
        121: "鹽埕區",
        122: "鼓山區",
        123: "左營區",
        124: "楠梓區",
        125: "三民區",
        126: "新興區",
        127: "前金區",
        128: "苓雅區",
        129: "前鎮區",
        130: "旗津區",
        131: "小港區",
        132: "鳳山區",
        133: "林園區",
        134: "大寮區",
        135: "大樹區",
        136: "大社區",
        137: "仁武區",
        138: "鳥松區",
        139: "岡山區",
        140: "橋頭區",
        141: "燕巢區",
        142: "田寮區",
        143: "阿蓮區",
        144: "路竹區",
        145: "湖內區",
        146: "茄萣區",
        147: "永安區",
        148: "彌陀區",
        149: "梓官區",
        150: "旗山區",
        151: "美濃區",
        152: "六龜區",
        153: "甲仙區",
        154: "杉林區",
        155: "內門區",
        156: "茂林區",
        157: "桃源區",
        158: "那瑪夏區",
        159: "中正區",
        160: "七堵區",
        161: "暖暖區",
        162: "仁愛區",
        163: "中山區",
        164: "安樂區",
        165: "信義區",
        166: "東區",
        167: "北區",
        168: "香山區",
        169: "東區",
        170: "西區",
        171: "竹東鎮",
        172: "關西鎮",
        173: "新埔鎮",
        174: "竹北市",
        175: "湖口鄉",
        176: "橫山鄉",
        177: "新豐鄉",
        178: "芎林鄉",
        179: "寶山鄉",
        180: "北埔鄉",
        181: "峨眉鄉",
        182: "尖石鄉",
        183: "五峰鄉",
        184: "苗栗巿",
        185: "苑裡鎮",
        186: "通霄鎮",
        187: "公館鄉",
        188: "銅鑼鄉",
        189: "三義鄉",
        190: "西湖鄉",
        191: "頭屋鄉",
        192: "竹南鎮",
        193: "頭份鎮",
        194: "造橋鄉",
        195: "後龍鎮",
        196: "三灣鄉",
        197: "南庄鄉",
        198: "大湖鄉",
        199: "卓蘭鎮",
        200: "獅潭鄉",
        201: "泰安鄉",
        202: "彰化巿",
        203: "鹿港鎮",
        204: "和美鎮",
        205: "北斗鎮",
        206: "員林鎮",
        207: "溪湖鎮",
        208: "田中鎮",
        209: "二林鎮",
        210: "線西鄉",
        211: "伸港鄉",
        212: "福興鄉",
        213: "秀水鄉",
        214: "花壇鄉",
        215: "芬園鄉",
        216: "大村鄉",
        217: "埔鹽鄉",
        218: "埔心鄉",
        219: "永靖鄉",
        220: "社頭鄉",
        221: "二水鄉",
        222: "田尾鄉",
        223: "埤頭鄉",
        224: "芳苑鄉",
        225: "大城鄉",
        226: "竹塘鄉",
        227: "溪州鄉",
        228: "南投巿",
        229: "埔里鎮",
        230: "草屯鎮",
        231: "竹山鎮",
        232: "集集鎮",
        233: "名間鄉",
        234: "鹿谷鄉",
        235: "中寮鄉",
        236: "魚池鄉",
        237: "國姓鄉",
        238: "水里鄉",
        239: "信義鄉",
        240: "仁愛鄉",
        241: "斗六市",
        242: "斗南鎮",
        243: "虎尾鎮",
        244: "西螺鎮",
        245: "土庫鎮",
        246: "北港鎮",
        247: "古坑鄉",
        248: "大埤鄉",
        249: "莿桐鄉",
        250: "林內鄉",
        251: "二崙鄉",
        252: "崙背鄉",
        253: "麥寮鄉",
        254: "東勢鄉",
        255: "褒忠鄉",
        256: "台西鄉",
        257: "元長鄉",
        258: "四湖鄉",
        259: "口湖鄉",
        260: "水林鄉",
        261: "朴子市",
        262: "布袋鎮",
        263: "大林鎮",
        264: "民雄鄉",
        265: "溪口鄉",
        266: "新港鄉",
        267: "六腳鄉",
        268: "東石鄉",
        269: "義竹鄉",
        270: "鹿草鄉",
        271: "太保巿",
        272: "水上鄉",
        273: "中埔鄉",
        274: "竹崎鄉",
        275: "梅山鄉",
        276: "番路鄉",
        277: "大埔鄉",
        278: "阿里山鄉",
        279: "屏東巿",
        280: "潮州鎮",
        281: "東港鎮",
        282: "恆春鎮",
        283: "萬丹鄉",
        284: "長治鄉",
        285: "麟洛鄉",
        286: "九如鄉",
        287: "里港鄉",
        288: "鹽埔鄉",
        289: "高樹鄉",
        290: "萬巒鄉",
        291: "內埔鄉",
        292: "竹田鄉",
        293: "新埤鄉",
        294: "枋寮鄉",
        295: "新園鄉",
        296: "崁頂鄉",
        297: "林邊鄉",
        298: "南州鄉",
        299: "佳冬鄉",
        300: "琉球鄉",
        301: "車城鄉",
        302: "滿州鄉",
        303: "枋山鄉",
        304: "三地門鄉",
        305: "霧臺鄉",
        306: "瑪家鄉",
        307: "泰武鄉",
        308: "來義鄉",
        309: "春日鄉",
        310: "獅子鄉",
        311: "牡丹鄉",
        312: "宜蘭巿",
        313: "頭城鎮",
        314: "礁溪鄉",
        315: "壯圍鄉",
        316: "員山鄉",
        317: "羅東鎮",
        318: "五結鄉",
        319: "冬山鄉",
        320: "蘇澳鎮",
        321: "三星鄉",
        322: "大同鄉",
        323: "南澳鄉",
        324: "花蓮巿",
        325: "光復鄉",
        326: "玉里鎮",
        327: "新城鄉",
        328: "吉安鄉",
        329: "壽豐鄉",
        330: "鳳林鎮",
        331: "豐濱鄉",
        332: "瑞穗鄉",
        333: "富里鄉",
        334: "秀林鄉",
        335: "萬榮鄉",
        336: "卓溪鄉",
        337: "台東巿",
        338: "成功鎮",
        339: "關山鎮",
        340: "卑南鄉",
        341: "大武鄉",
        342: "太麻里鄉",
        343: "東河鄉",
        344: "長濱鄉",
        345: "鹿野鄉",
        346: "池上鄉",
        347: "綠島鄉",
        348: "延平鄉",
        349: "海端鄉",
        350: "達仁鄉",
        351: "金峰鄉",
        352: "蘭嶼鄉",
        353: "馬公巿",
        354: "湖西鄉",
        355: "白沙鄉",
        356: "西嶼鄉",
        357: "望安鄉",
        358: "七美鄉",
        359: "金湖鎮",
        360: "金沙鎮",
        361: "金城鎮",
        362: "金寧鄉",
        363: "烈嶼鄉",
        364: "烏坵鄉",
        365: "南竿鄉",
        366: "北竿鄉",
        367: "莒光鄉",
        368: "東引鄉"
    },
    E_AREA_ZIP: {
        1: "105",
        2: "106",
        3: "100",
        4: "108",
        5: "103",
        6: "104",
        7: "116",
        8: "115",
        9: "114",
        10: "111",
        11: "112",
        12: "110",
        13: "242",
        14: "244",
        15: "248",
        16: "247",
        17: "241",
        18: "243",
        19: "231",
        20: "223",
        21: "222",
        22: "232",
        23: "233",
        24: "220",
        25: "237",
        26: "239",
        27: "238",
        28: "235",
        29: "236",
        30: "224",
        31: "226",
        32: "227",
        33: "228",
        34: "208",
        35: "207",
        36: "251",
        37: "221",
        38: "252",
        39: "253",
        40: "249",
        41: "234",
        42: "330",
        43: "335",
        44: "320",
        45: "326",
        46: "338",
        47: "337",
        48: "333",
        49: "334",
        50: "325",
        51: "324",
        52: "327",
        53: "328",
        54: "336",
        55: "400",
        56: "401",
        57: "403",
        58: "402",
        59: "404",
        60: "407",
        61: "498",
        62: "406",
        63: "420",
        64: "423",
        65: "437",
        66: "436",
        67: "433",
        68: "435",
        69: "429",
        70: "421",
        71: "428",
        72: "427",
        73: "426",
        74: "422",
        75: "438",
        76: "439",
        77: "414",
        78: "432",
        79: "434",
        80: "413",
        81: "411",
        82: "412",
        83: "424",
        84: "701",
        85: "702",
        86: "704",
        87: "709",
        88: "708",
        89: "700",
        90: "730",
        91: "737",
        92: "732",
        93: "736",
        94: "731",
        95: "733",
        96: "721",
        97: "735",
        98: "734",
        99: "720",
        100: "742",
        101: "722",
        102: "723",
        103: "724",
        104: "725",
        105: "727",
        106: "726",
        107: "712",
        108: "741",
        109: "744",
        110: "745",
        111: "743",
        112: "714",
        113: "715",
        114: "716",
        115: "713",
        116: "717",
        117: "711",
        118: "718",
        119: "719",
        120: "710",
        121: "803",
        122: "804",
        123: "813",
        124: "811",
        125: "807",
        126: "800",
        127: "801",
        128: "802",
        129: "806",
        130: "805",
        131: "812",
        132: "830",
        133: "832",
        134: "831",
        135: "840",
        136: "815",
        137: "814",
        138: "833",
        139: "820",
        140: "825",
        141: "824",
        142: "823",
        143: "822",
        144: "821",
        145: "829",
        146: "852",
        147: "828",
        148: "827",
        149: "826",
        150: "842",
        151: "843",
        152: "844",
        153: "847",
        154: "846",
        155: "845",
        156: "851",
        157: "848",
        158: "849",
        159: "202",
        160: "206",
        161: "205",
        162: "200",
        163: "203",
        164: "204",
        165: "201",
        166: "300",
        167: "300",
        168: "300",
        169: "600",
        170: "600",
        171: "310",
        172: "306",
        173: "305",
        174: "302",
        175: "303",
        176: "312",
        177: "304",
        178: "307",
        179: "308",
        180: "314",
        181: "315",
        182: "313",
        183: "311",
        184: "360",
        185: "358",
        186: "357",
        187: "363",
        188: "366",
        189: "367",
        190: "368",
        191: "362",
        192: "350",
        193: "351",
        194: "361",
        195: "356",
        196: "352",
        197: "353",
        198: "364",
        199: "369",
        200: "313",
        201: "365",
        202: "500",
        203: "505",
        204: "508",
        205: "521",
        206: "510",
        207: "514",
        208: "520",
        209: "526",
        210: "507",
        211: "509",
        212: "506",
        213: "504",
        214: "503",
        215: "502",
        216: "515",
        217: "516",
        218: "513",
        219: "512",
        220: "511",
        221: "530",
        222: "522",
        223: "523",
        224: "528",
        225: "527",
        226: "525",
        227: "524",
        228: "540",
        229: "545",
        230: "542",
        231: "557",
        232: "552",
        233: "551",
        234: "558",
        235: "541",
        236: "555",
        237: "544",
        238: "553",
        239: "556",
        240: "546",
        241: "640",
        242: "630",
        243: "632",
        244: "648",
        245: "633",
        246: "651",
        247: "646",
        248: "631",
        249: "647",
        250: "643",
        251: "649",
        252: "637",
        253: "638",
        254: "635",
        255: "634",
        256: "636",
        257: "655",
        258: "654",
        259: "653",
        260: "652",
        261: "613",
        262: "625",
        263: "622",
        264: "621",
        265: "623",
        266: "616",
        267: "615",
        268: "614",
        269: "624",
        270: "611",
        271: "612",
        272: "608",
        273: "606",
        274: "604",
        275: "603",
        276: "602",
        277: "607",
        278: "605",
        279: "900",
        280: "920",
        281: "928",
        282: "946",
        283: "913",
        284: "908",
        285: "909",
        286: "904",
        287: "905",
        288: "907",
        289: "906",
        290: "923",
        291: "912",
        292: "911",
        293: "925",
        294: "940",
        295: "932",
        296: "924",
        297: "927",
        298: "926",
        299: "931",
        300: "929",
        301: "944",
        302: "947",
        303: "941",
        304: "901",
        305: "902",
        306: "903",
        307: "921",
        308: "922",
        309: "942",
        310: "943",
        311: "945",
        312: "260",
        313: "261",
        314: "262",
        315: "263",
        316: "264",
        317: "265",
        318: "268",
        319: "269",
        320: "270",
        321: "266",
        322: "267",
        323: "272",
        324: "970",
        325: "976",
        326: "981",
        327: "971",
        328: "973",
        329: "974",
        330: "975",
        331: "977",
        332: "978",
        333: "983",
        334: "972",
        335: "979",
        336: "982",
        337: "950",
        338: "961",
        339: "956",
        340: "954",
        341: "965",
        342: "963",
        343: "959",
        344: "962",
        345: "955",
        346: "958",
        347: "951",
        348: "953",
        349: "957",
        350: "966",
        351: "964",
        352: "952",
        353: "880",
        354: "885",
        355: "884",
        356: "881",
        357: "882",
        358: "883",
        359: "891",
        360: "890",
        361: "893",
        362: "892",
        363: "894",
        364: "896",
        365: "209",
        366: "210",
        367: "211",
        368: "212"
    },
    E_CITY_AREA: {
        1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        2: [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41],
        3: [42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54],
        4: [55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83],
        5: [84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120],
        6: [121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158],
        7: [159, 160, 161, 162, 163, 164, 165],
        8: [166, 167, 168],
        9: [169, 170],
        10: [171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183],
        11: [184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201],
        12: [202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227],
        13: [228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
        14: [241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260],
        15: [261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278],
        16: [279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311],
        17: [312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323],
        18: [324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336],
        19: [337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352],
        20: [353, 354, 355, 356, 357, 358],
        21: [359, 360, 361, 362, 363, 364],
        22: [365, 366, 367, 368]
    },
    E_QUESTION_TYPE: {
        SINGLE: 1,
        MULTIPLE: 2,
        DROP_DOWN: 3,
        OPEN: 4,
        RULER: 5,
        ARRAY: 6,
        ORDER: 7,
        COMPARE: 8,
        ADDRESS: 9
    },
    E_ADMIN: {
        ADMIN: 1,
        NORMAL: 2,
        INCUBATOR: 3
    },
    E_AGE_TEXT: {
        0: "不限定",
        1: "15+",
        2: "18+",
        3: "20+",
        4: "30+"
    },
    E_AREA_TEXT: {
        0: "不限定",
        1: "六都",
        2: "北部地區",
        3: "中部地區",
        4: "南部地區"
    },
    E_AREA_PS_TEXT: {
        0: "",
        1: "(台北市、新北市、桃園市、台中市、台南市、高雄市)",
        2: "(台北市、新北市、桃園市、基隆市、宜蘭縣、新竹縣市)",
        3: "(台中市、苗栗縣、花蓮縣、彰化縣、南投縣、雲林縣)",
        4: "(台南市、高雄市、嘉義縣市、台東縣、屏東縣)"
    },
    E_AREA_TEXT_SHORT: {
        0: "不限定",
        1: "六都",
        2: "北部",
        3: "中部",
        4: "南部"
    },
    E_QUOTA: [
        100, 200, 300, 400, 500
    ],
    E_QUESTION_TYPE_TEXT: {
        1: "單選題",
        2: "複選題",
        3: "下拉題",
        4: "開放題",
        5: "尺規",
        6: "矩陣",
        // 7: "排序",
        // 8: "比較",
        // 9: "地址"
    },
    E_QUESTION_TYPE_INDEX: {
        SINGLE: 1,
        MULTIPLE: 2,
        DRAG: 3,
        OPEN: 4,
        RULER: 5,
        ARRAY: 6
    }
};

export default Enums;